import React from 'react';
import { connect } from 'react-redux';
import { Element } from '@americanexpress/aqx-components';
import BenefitItem from './BenefitItem';
import BoxContainer from './BoxContainer';
import {
  getOverriddenLabels,
  getPdpFeaturedBenefitsData
} from 'page_modules/business-pdp/redux';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import withPropTestingData from 'src/universal/components/WithPropTestingData';
import { DATA_TYPES } from 'src/universal/redux/propTesting';
import styles from './__styles__/featureBenefitBox.scss?modules';

const pointsFeatureKeyVal = 'pointsFeature';

const hasValidContent = (contentList = []) => {
  if (!Array.isArray(contentList) || contentList.length < 1) {
    return false;
  }

  if (contentList.length === 1 && contentList[0].key === pointsFeatureKeyVal) {
    return false;
  }

  return true;
};

const paddingObj = {
  paddingTop: 25,
  paddingBottom: 25,
  paddingLeft: 20,
  paddingRight: 20
};

const FeaturedRow = feature => {
  return (
    <li style={{ listStyle: 'none' }} id={feature.scrollFrom}>
      <BoxContainer
        styles={feature.styles}
        padding={feature.featureKey === 'benefitWithLogoAndImage' ? {} : paddingObj}
      >
        <BenefitItem {...feature} styles={styles} />
      </BoxContainer>
    </li>
  );
};

const FeaturedBenefits = ({ featuredBenefits, cardName, dtm }) => {
  const isPlatinum = cardName === 'platinum';

  if (isPlatinum || !hasValidContent(featuredBenefits)) return null;
  return (
    <div className={styles.featureBenefitsSection}>
      <Element
        Component="ul"
        theme={{ padding: 'none', margin: 'none', textBody: 1 }}
      >
        {featuredBenefits.map(
          (feature, index) =>
            feature.key === pointsFeatureKeyVal ? (
              <LazyScrollMetricTracker
                startTrackingAfterPznArrival={true}
                scrollDtm={dtm}
                key={index}
              />
            ) : (
              <FeaturedRow
                {...feature}
                isFirstBenefit={index === 0}
                featureKey={feature.key}
                styles={styles}
                key={index}
              />
            )
        )}
      </Element>
    </div>
  );
};

const PropsTestedFeaturedBenefits = withPropTestingData(
  FeaturedBenefits,
  'FeaturedBenefits',
  DATA_TYPES.cardData
);

const mapStateToProps = state => ({
  featuredBenefits: getPdpFeaturedBenefitsData(state),
  overriddenLabels: getOverriddenLabels(state)
});

export default connect(mapStateToProps)(PropsTestedFeaturedBenefits);
